// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "proto/common/quotelevel.proto" (package "proto.common", syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "proto/common/quotelevel.proto" (package "proto.common", syntax proto3)
// tslint:disable

/**
 * inspired from https://en.wikipedia.org/wiki/Financial_quote
 *
 * @generated from protobuf enum proto.common.QuoteLevel
 */
export var QuoteLevel;

(function (QuoteLevel) {
  /**
   * @generated from protobuf enum value: LAST_PRICE = 0;
   */
  QuoteLevel[QuoteLevel["LAST_PRICE"] = 0] = "LAST_PRICE";
  /**
   * @generated from protobuf enum value: BEST_BID_OFFER = 1;
   */

  QuoteLevel[QuoteLevel["BEST_BID_OFFER"] = 1] = "BEST_BID_OFFER";
  /**
   * @generated from protobuf enum value: DEPTH_OF_MARKET = 2;
   */

  QuoteLevel[QuoteLevel["DEPTH_OF_MARKET"] = 2] = "DEPTH_OF_MARKET";
  /**
   * @generated from protobuf enum value: DEPTH_OF_BOOK = 3;
   */

  QuoteLevel[QuoteLevel["DEPTH_OF_BOOK"] = 3] = "DEPTH_OF_BOOK";
  /**
   * @generated from protobuf enum value: ACCESS_FORBIDDEN = 4;
   */

  QuoteLevel[QuoteLevel["ACCESS_FORBIDDEN"] = 4] = "ACCESS_FORBIDDEN";
})(QuoteLevel || (QuoteLevel = {}));